const CompletedOrdersPanel: React.FC = () => null;

export default CompletedOrdersPanel;
